module.exports = __webpack_public_path__ + "img/logo_mobly_atendimento.8241a83d.svg";